import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
export var PLACEHOLDER_IMAGE = IImage.build({
    token: "p_placeholder",
    url: EAEAEA_PIXEL
});
